import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Link } from '../../models/link.interface';

@Component({
  selector: 'app-link-item',
  templateUrl: './link-item.component.html',
  styleUrls: ['./link-item.component.scss'],
})
export class LinkItemComponent implements OnInit {
  @Input() link?: Link;
  @Output() onUpdateLink = new EventEmitter<Link>();
  @Output() onDeleteLink = new EventEmitter<Link>();

  constructor() {}

  ngOnInit(): void {}

  updateLink(link: Link) {
    this.onUpdateLink.emit(link);
  }

  deleteLink(link: Link) {
    this.onDeleteLink.emit(link);
  }
}
